<template>
  <div class="verified-badge">
    <span class="verified-badge__icon" aria-hidden="true">
      <CheckGeneric />
    </span>
    {{ $t('review.verifiedLabel') }}
  </div>
</template>
<script lang="ts" setup>
import CheckGeneric from '~/assets/icons/check-generic.svg?component'
</script>
<style lang="postcss" scoped>
.verified-badge {
  @apply flex items-center;
  @apply bg-lime-50 border border-lime-700;
  @apply rounded-md pr-2 pl-1.5;
  @apply text-lime-800 text-sm;
}

.verified-badge__icon {
  @apply inline-flex shrink-0 items-center justify-center overflow-hidden;
  @apply size-4 mr-1;
}

.verified-badge__icon :deep(svg) {
  @apply size-[18px];
}
</style>
